/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.brands.BrandsNavigationBlock
*/
export interface BrandsNavigationBlock extends NavigationBlock {
	
}
export const isBrandsNavigationBlock = (model: unknown): model is BrandsNavigationBlock => (model as BrandsNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.brands.BrandsNavigationBlock';

